<template>
    <div id="il-network" class="section network" v-if="this.dataLoaded">
        <GridLines />
        <div class="big-title">
            <h1 v-html="this.page.attributes.title"></h1>
        </div>
        <div class="container custom">
            <div class=" custom col-md-12 col-lg-4">
                <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000" v-html="this.page.attributes.title"></h1>
                <p v-html="this.page.attributes.field_description.processed"></p>
                <br>
                <a href="https://iusful.com/" target="_blank"><img src="../assets/iusful-logo.png" alt=""></a>
                <h5><a href="https://iusful.com/" target="_blank">{{labelTrad}} IUSFUL.com</a></h5>
            </div>
        </div>
        <MapNetwork  />
    </div>
</template>
<script>
import GridLines from '@/components/GridLines.vue'
import MapNetwork from '@/components/MapNetwork.vue'

export default {
  name: 'section-network',
  components:{
      GridLines,
      MapNetwork
  },
  props: {
      dataPages: {
          type: String
      }
  },
  data:()=>{
        return {
            idIntroPage:"f3c58f84-d2d4-449a-bf1a-99ff8848d626",
            page:[],
            dataLoaded:false
        }
  },
  computed:{
      labelTrad(){
        if(this.$route.params.lang == "it"){
            return "Vai al Sito "
        } else{
            return "See "
        }
            
    },

  },
methods:{
    splittedTitle: function (value) {
        return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    }
},
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h5 a {
    color: #14182E;
    font-size: 0.875rem;
    margin-top: 8px;
}
.network.section .container {
    padding-top: 0rem;
}

.network {
   &:before {
        position: absolute;
        background: #E3E3E3 url("../assets/network-map-mobile.png") center;
        background-position: top;
        background-size: 100%;
        background-repeat: no-repeat;
        content: "";
        width: 100%;
        height: 100%;
        display: block;
    }
    &>.container.custom{
        position: relative;
        z-index: 1;
        padding-top: 5rem;
    }
    .big-title {
        z-index: 4;
    }

}
.container.custom {
    padding: 0;
    pointer-events: none;
    a {
        pointer-events: all;
    }
}

.hotspot > div p {
    color: #4b4b4b;
}
@media (max-width: 992px){
    .network.section >.container{
        padding-top: 2rem;
        padding-bottom: 3rem;
    }
    .network .read-more {
        text-align: center;
    }
    .network.section .container-map.container {
        padding-top: 0rem;
        padding-bottom: 3rem;
    }
}
</style>
